import * as React from 'react';
import { AppComponentProps } from '../../typescriptHelpers';
import { AppUsersTable } from './AppUsersTable';
import Space from 'antd/lib/space';
interface TeamRolesProps extends AppComponentProps {
    refProp?: React.MutableRefObject<HTMLDivElement>;
}

const TeamRoles: React.FC<TeamRolesProps> = (props: TeamRolesProps) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column' }} ref={props.refProp}>
            <Space direction="vertical" size={40}>
                <AppUsersTable {...props} />
            </Space>
        </div>
    );
};

export default TeamRoles;
